// extracted by mini-css-extract-plugin
export default {"choose-way":"g__choose-way--gngx8"};